<header mat-dialog-title>
  <h3>
    {{ data.existingConnector ? 'Edit' : 'Add' }}
    <b>{{ data.connector.name }}</b> connector configuration
  </h3>
  <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</header>
<mat-dialog-content>
  <form
    *ngIf="!formPreparing"
    [formGroup]="addConnectorForm.get('configurations')"
  >
    <div
      *ngFor="let element of data.connector.configurations"
      class="form-field-wrapper"
    >
      <mat-form-field
        *ngIf="element.inputType !== 'boolean'"
        appearance="fill"
        [hintLabel]="element.description"
      >
        <mat-label>{{ element.label }}</mat-label>
        <input
          matInput
          [formControlName]="element.key"
          [placeholder]="element.key"
          [type]="element.inputType === 'number' ? 'number' : 'text'"
          [required]="element.required"
        />
      </mat-form-field>
      <div class="checkbox-wrapper" *ngIf="element.inputType === 'boolean'">
        <mat-label>{{ element.label }}</mat-label>
        <mat-checkbox
          labelPosition="before"
          [formControlName]="element.key"
          [required]="element.required"
        ></mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">Cancel</button>
  <button
    *ngIf="!formPreparing"
    mat-raised-button
    color="primary"
    [disabled]="disabled"
    (click)="submitForm()"
  >
    Submit
  </button>
</mat-dialog-actions>
